import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { Monogram } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
    } catch (err) {}
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <Monogram size={52} />
        </div>
        <h1 className="font-brand font-light text-3xl tracking-tight mb-1 text-center">Reset password</h1>
        {sent ? (
          <div className="text-center mt-6 space-y-6">
            <p className="text-sm text-muted-foreground" data-testid="forgot-confirmation">
              If that email is registered, a reset link has been sent. Please check your inbox.
            </p>
            <Link to="/login" className="inline-block text-sm underline" data-testid="back-to-login-link">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <p className="text-muted-foreground text-sm mb-8 text-center">
              Enter your email and we'll send you a link to reset your password.
            </p>
            <form onSubmit={submit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" className="w-full rounded-full h-11" disabled={loading} data-testid="forgot-submit-button">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
              <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">
                Back to sign in
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
